import * as liveReq from './live';
import * as userReq from './user';
import * as homeReq from './home';
import * as meetReq from './meeting';
import * as exerReq from './exercise';
import * as videoReq from './video';
import * as apiReq from './api';
import * as mallReq from './mall';
import * as payReq from './pay';
import * as dataReq from './data';
export { liveReq, userReq, homeReq, meetReq, videoReq, apiReq, mallReq, exerReq, payReq, dataReq };
